import React from 'react';
import { View, Field, Table, Text, Page } from '../../components';
import {
  aggregateDeadlines,
  limitString,
  paginateArray,
} from '../../../../helpers/utils';
import { Theme } from '../../../../theme';

const deadlineColumns = [
  {
    Header: 'Project Name',
    accessor: 'description',
    Cell: ({ cell: { value } }) => (value ? limitString(value, 80) : '--'),
  },
  {
    Header: 'Action Name',
    accessor: 'title',
    Cell: ({ cell: { value } }) => value || '--',
  },
  {
    Header: 'Client',
    accessor: 'client_name',
  },
  {
    Header: 'Funder',
    accessor: 'funder_name',
  },
  {
    Header: 'Assigned To',
    accessor: 'assignee_name',
    Cell: ({ cell: { value } }) => value || '--',
  },
  {
    Header: 'Deadline',
    accessor: 'deadline',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
];

interface Props {
  data: any[];
  meta: any;
}

const DeadlinesReport = ({ data: deadlines, meta }: Props) => {
  const initialData = deadlines.slice(0, 4);
  const remainingData = paginateArray(deadlines.slice(4));

  const { actions, projects, totalDeadlines } = aggregateDeadlines(deadlines);
  const clientNames = deadlines
    .map((item) => item.client_name)
    .filter((item, index, arr) => arr.indexOf(item) === index)
    .join('; ');

  return (
    <>
      <Page meta={meta}>
        <View>
          <View>
            <View
              pb={1}
              mb={3}
              borderBottom={`1pt solid ${Theme.colors.primary}`}
              width="100%"
            >
              <Text fontSize="14pt">Aggregates</Text>
            </View>
            <Field label="Clients" value={clientNames} />
            <Field label="Projects" value={projects} />
            <Field label="Actions" value={actions} />
            <Field label="Total Deadlines" value={totalDeadlines} />
          </View>
          <View
            pb={1}
            mb={3}
            mt={4}
            borderBottom={`1pt solid ${Theme.colors.primary}`}
            width="100%"
          >
            <Text fontSize="14pt">Deadlines</Text>
          </View>
          <Table
            data={initialData}
            columns={deadlineColumns}
            name="deadlines"
          />
        </View>
      </Page>
      {remainingData.map((data, i) => (
        <Page meta={meta} key={`page_${i + 1}`}>
          <Table data={data} columns={deadlineColumns} />
        </Page>
      ))}
    </>
  );
};

export default DeadlinesReport;
